import { Outlet, createFileRoute, useLocation } from '@tanstack/react-router'

import { ZaloShell } from '@/components/zalo/zalo-shell'
import { requireServerFlag } from '@/lib/server-flag-guard'
import { queryClient } from '@/router'

// Quản trị › Zalo ZBS (spec 2026-10-08 §8): khung 4 tab dùng chung.
// ZALO_OA_ENABLED tắt → cả 4 tab và trang chi tiết mẫu không tồn tại.
export const Route = createFileRoute('/_app/_authed/_sidebar/settings/zalo')({
    beforeLoad: () => requireServerFlag(queryClient, 'server:zalo-oa'),
    component: ZaloLayout,
})

function ZaloLayout() {
    const { pathname } = useLocation()
    return (
        <ZaloShell pathname={pathname}>
            <Outlet />
        </ZaloShell>
    )
}
